import React from 'react';
import styled from 'styled-components';

import { formatPercentage, formatPricePerHour } from '@front/common/src/utils/formatting';
import { getCurrentCountry } from '@front/common/src/utils/country';

import { MEMBERSHIP_CONFIG_BY_COUNTRY } from '@front/customer/src/constants/country-config';

import { translate } from '@front/i18n';

import Title from '@front/web-ui/src/components/base-text/variants/title';
import Text from '@front/web-ui/src/components/base-text/variants/text';

const t = translate('modals.membership_paywall');

const Advantage = styled.div`
  display: flex;
  margin-bottom: 20px;
  align-items: center;
`;

const AdvantageTitle = styled(Title)`
  margin-right: 10px;
  min-width: 70px;
`;

const Advantages = () => {
  const currentCountry = getCurrentCountry();

  const membershipConfig = MEMBERSHIP_CONFIG_BY_COUNTRY[currentCountry];
  const formattedWellnessMemberReductionPercentage = formatPercentage(membershipConfig.wellnessReductionsPercentage);
  const formattedCleaningMemberHourlyReduction = formatPricePerHour(membershipConfig.cleaningMaxPricePerHour, {
    precision: 0,
  });

  return (
    <>
      <Advantage>
        <AdvantageTitle>
          {t('.advantages.wellness.title', {
            reductionsPercentage: formattedWellnessMemberReductionPercentage,
          })}
        </AdvantageTitle>
        <Text.SM>
          {t('.advantages.wellness.content', {
            reductionsPercentage: formattedWellnessMemberReductionPercentage,
          })}
        </Text.SM>
      </Advantage>
      <Advantage>
        <AdvantageTitle>
          {t('.advantages.cleaning.title', {
            pricePerHour: formattedCleaningMemberHourlyReduction,
          })}
        </AdvantageTitle>
        <Text.SM>
          {t('.advantages.cleaning.content', {
            pricePerHour: formattedCleaningMemberHourlyReduction,
          })}
        </Text.SM>
      </Advantage>
    </>
  );
};

export default Advantages;
